/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import Head from 'next/head';
import { forwardRef } from 'react';
import { AppendPageHeadTitle } from 'v4/snippets/custom-head';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { SearchArticles } from 'v4/snippets/search/articles';
import { SearchLayout } from 'v4/snippets/search/layout';
export default forwardRef(({ ...props }, ref) => {
  const { t } = useTranslator();
  return (
    <AuthenticatedProviders>
      <SearchLayout activeTab={'articles'}>
        <Head>
          <title> {t('otherPage.postBlogArticle') || "Post Blogs/Articles on myBridge for Global Visibility"}</title>
          <meta name="og:title" content="Post Blogs/Articles on myBridge for Global Visibility" />
          <meta
            name="description"
            content="Submit articles on our platform and reach a diverse audience. Contribute, inspire, and connect with readers worldwide. Start sharing your knowledge today!"
          />
          <meta
            name="keywords"
            content="Submit articles, article submission websites, top article submission websites 2023, Top 20 Article Submission Websites, Publish your article "
          />
          <meta
            name="og:description"
            content="Submit articles on our platform and reach a diverse audience. Contribute, inspire, and connect with readers worldwide. Start sharing your knowledge today!"
          />
        <link
          rel="canonical"
          href={`${typeof window !== 'undefined' && window.location.href}`}
        />
        </Head>
        <SearchArticles />
      </SearchLayout>
    </AuthenticatedProviders>
  );
});
